import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class ClassroomOptionItem extends OptionItem {
  constructor(classroom) {
    const { classroomId, name } = classroom;
    super({ id: classroomId, text: name, data: classroom });
  }
}
